import template from './time-title.html';
import controller from './time-title.controller';
import './time-title.scss';

let titleComponent = {
  bindings: {},
  template,
  controller
};

export default titleComponent;



// WEBPACK FOOTER //
// ./client/app/components/title-time/time-title.component.js